// src/pages/RecoverPasswordPage.tsx

import React, { useState } from 'react';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useNotification } from '../context/NotificationContext'; 

const RecoverPasswordPage: React.FC = () => {
    const [email, setEmail] = useState('');
    const [isSending, setIsSending] = useState(false);
    const { addNotification } = useNotification();

    const handleRecovery = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (!email) {
            addNotification('Por favor, ingresa tu correo electrónico.', 'error');
            return;
        }

        setIsSending(true);
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        setIsSending(false);

        addNotification(`Si ${email} está registrado, recibirás un enlace para restablecer tu contraseña.`, 'info');
        setEmail('');
    };

    return (
        <div style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'var(--color-fondo)',
            padding: '20px'
        }}>
            <div style={{ 
                background: 'white', 
                padding: '40px', 
                borderRadius: '16px', 
                boxShadow: '0 8px 30px rgba(0,0,0,0.1)', 
                width: '100%', 
                maxWidth: '400px',
                textAlign: 'center'
            }}>
                <img 
                    src="/Profunding_Azul.png" 
                    alt="ProFunding" 
                    style={{ maxWidth: '180px', height: 'auto', margin: '0 auto 25px auto', display: 'block' }} 
                />

                <h1 style={{ fontSize: '1.5rem', color: '#333', marginBottom: '10px', fontWeight: 700 }}>
                    ¿Olvidaste tu Contraseña?
                </h1>
                <p style={{ color: '#666', marginBottom: '30px', fontSize: '0.95rem' }}>
                    Ingresa el correo asociado a tu cuenta para enviarte un enlace de restablecimiento.
                </p>

                <form onSubmit={handleRecovery} style={{ textAlign: 'left' }}>
                    <div style={{ marginBottom: '30px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 600, color: '#444', fontSize: '0.9rem' }}>
                            Correo Electrónico
                        </label>
                        <div style={{ position: 'relative' }}>
                            <FiMail style={{ position: 'absolute', left: '14px', top: '14px', color: '#999' }} />
                            <input 
                                type="email" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="ej. nombre@empresa.com"
                                style={{ 
                                    width: '100%', padding: '14px 14px 14px 40px', borderRadius: '10px', 
                                    border: '1px solid #e0e0e0', fontSize: '1rem',
                                    backgroundColor: '#f9f9f9', outline: 'none'
                                }}
                                required
                            />
                        </div>
                    </div>

                    <button 
                        type="submit" 
                        disabled={isSending}
                        style={{ 
                            width: '100%', 
                            padding: '15px', 
                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)', 
                            color: 'white', 
                            border: 'none', 
                            borderRadius: '12px', 
                            fontSize: '1rem', 
                            fontWeight: 700, 
                            cursor: isSending ? 'wait' : 'pointer',
                            opacity: isSending ? 0.8 : 1,
                            boxShadow: '0 4px 15px rgba(103, 58, 183, 0.3)',
                            transition: 'transform 0.2s'
                        }}
                    >
                        {isSending ? 'Enviando...' : 'Restablecer Contraseña'}
                    </button>
                </form>

                <div style={{ marginTop: '25px', fontSize: '0.9rem' }}>
                    <Link to="/" style={{ 
                        color: 'var(--color-texto-secundario)', 
                        textDecoration: 'none', 
                        fontWeight: 600, 
                        display: 'inline-flex', 
                        alignItems: 'center', 
                        gap: '5px' 
                    }}>
                        <FiArrowLeft /> Regresar a la página de Inicio
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default RecoverPasswordPage;